import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import SelectorButtonContainer from '../../components/SelectorButtonContainer';
import ProductButton from '../../components/ProductButton';
import { EmotionBreakpoint } from 'dw-us-ui';
import { getPageHeroBannerFields } from '../../utils/landingPageData';
// ${EmotionBreakpoint('tablet')} {

// ${EmotionBreakpoint('mobile')} {

// Build the desktop hero background: image with optional dark gradient overlay.
const buildHeroDesktopBg = ({ backgroundImageUrl, showGradient }, fallback) => {
	if (!backgroundImageUrl) return fallback;
	return showGradient
		? `linear-gradient(90deg, #000000 16.74%, rgba(0, 0, 0, 0) 69.48%),url(https:${backgroundImageUrl})`
		: `url(https:${backgroundImageUrl})`;
};

// Build the mobile hero background: image with optional dark gradient overlay.
const buildHeroMobileBg = (
	{ backgroundImageMobileUrl, showGradient },
	fallback
) => {
	if (!backgroundImageMobileUrl) return fallback;
	return showGradient
		? `linear-gradient(0deg, #000000 55%, rgba(0, 0, 0, 0) 90%),url(https:${backgroundImageMobileUrl})`
		: `url(https:${backgroundImageMobileUrl})`;
};

// Styled Components

const HeroContainerAdjust = styled.div`
	height: 80px;
	&.has-richtext {
		height: auto;
	}
	${EmotionBreakpoint('mobile')} {
		height: 20px;
	}
	${EmotionBreakpoint('tablet')} {
		height: auto;
	}
`;
const BannerHeightAdjust = styled.div`
	height: ${({ isBackgroundMode }) => (isBackgroundMode ? '86px' : '0')};
	${EmotionBreakpoint('mobile')} {
		.bon & {
			height: ${({ isBackgroundMode }) => (isBackgroundMode ? '76px' : '0')};
		}
		.fox & {
			height: ${({ isBackgroundMode }) => (isBackgroundMode ? '76px' : '0')};
		}
	}
`;

const HeroContainer = styled.div`
	position: relative;
	height: 650px;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: ${(props) => buildHeroDesktopBg(props, '#ededed')};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	@media (max-width: 500px) {
		background: ${(props) => buildHeroMobileBg(props, '#ededed')};
		background-size: 100% auto;
		background-position: center top;
		background-repeat: no-repeat;
	}

	/* When rich text is present, allow container to grow */
	&.has-richtext {
		height: auto;
		min-height: 650px;
	}
	.container-position {
		position: relative;
		top: -1px;
	}

	.fox & {
		background: ${(props) => buildHeroDesktopBg(props, '#f8f8f8')};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		@media (max-width: 500px) {
			background: ${(props) => buildHeroMobileBg(props, '#f8f8f8')};
			background-size: 100% auto;
			background-position: center top;
			background-repeat: no-repeat;
		}
	}

	.bon & {
		background: ${(props) => buildHeroDesktopBg(props, '#f8f8f8')};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		@media (max-width: 500px) {
			background: ${(props) => buildHeroMobileBg(props, '#f8f8f8')};
			background-size: 100% auto;
			background-position: center top;
			background-repeat: no-repeat;
		}
	}
	.law & {
		background: ${(props) => buildHeroDesktopBg(props, '#f8f5ef')};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		@media (max-width: 500px) {
			background: ${(props) => buildHeroMobileBg(props, '#f8f5ef')};
			background-size: 100% auto;
			background-position: center top;
			background-repeat: no-repeat;
		}
	}
	.osw & {
		background: ${(props) => buildHeroDesktopBg(props, '#f8f5ef')};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		@media (max-width: 500px) {
			background: ${(props) => buildHeroMobileBg(props, '#f8f5ef')};
			background-size: 100% auto;
			background-position: center top;
			background-repeat: no-repeat;
		}
	}
	.npr & {
		background: ${(props) => buildHeroDesktopBg(props, '#ededed')};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		@media (max-width: 500px) {
			background: ${(props) => buildHeroMobileBg(props, '#ededed')};
			background-size: 100% auto;
			background-position: center top;
			background-repeat: no-repeat;
		}
	}

	${EmotionBreakpoint('mobile')} {
		padding: 0px;
		height: auto;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 0px;
		height: auto;
	}
`;

const HeroInner = styled.div`
	display: flex;
	/* Reduce the top padding when the hero is not the first section on the page. */
	padding: ${({ isFirstSection }) =>
		isFirstSection ? '128px 6% 64px' : '60px 6% 64px'};
	gap: 80px;
	align-self: ${({ isBackgroundMode }) =>
		isBackgroundMode ? 'self-start' : 'auto'};
	${EmotionBreakpoint('mobile')} {
		flex-direction: column-reverse;
		padding: 0px;
		gap: 0px;
		width: 100%;
		padding-top: ${({ isFirstSection }) => (isFirstSection ? '77px' : '0')};
	}
	${EmotionBreakpoint('tablet')} {
		flex-direction: row;
		padding: 0px;
		gap: 0px;
		width: 100%;
		padding-top: ${({ isFirstSection }) => (isFirstSection ? '100px' : '0')};
	}
`;

const HeroInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	width: 598px;

	.fox & {
		& > *:first-child {
			align-self: baseline;
		}
	}
	.bon & {
		& > *:first-child {
			align-self: baseline;
		}
	}

	.lp-hero {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	${EmotionBreakpoint('mobile')} {
		width: 100%;
		flex: none; // Reset ratio on mobile
		padding: 16px;
		align-items: center;

		.lp-hero {
			text-align: left;
			width: 100%;
			padding-bottom: 5px;
		}
	}

	@media (max-width: 500px) {
		${({ isBackgroundMode }) => isBackgroundMode && `margin-top: 140px;`}
	}
	${EmotionBreakpoint('tablet')} {
		flex: 1;
		width: 100%;
		height: auto;
		padding: 16px;
		align-items: flex-start;

		.lp-hero {
			text-align: left;
			width: 100%;
			padding-bottom: 5px;
		}
	}

	.hero-form-product-button {
		width: 598px;
		margin-left: 0px;
		${EmotionBreakpoint('mobile')} {
			width: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
		}

		.law & {
			font-family: 'Roboto';
			font-weight: 600;
		}
		.bon & {
			font-family: 'FuturaPT';
			font-weight: 500;
		}
		.osw & {
			font-weight: 700;
			font-family: 'Roboto' !important;
		}
		.npr & {
			font-weight: 700;
			font-family: 'Roboto' !important;
		}
	}

	.hero-form-selector-container {
		display: flex;
		flex-direction: row;
		width: 100%;

		button {
			flex: 1;
			margin: 5px;
			.fox & {
				width: 191px !important;
			}

			${EmotionBreakpoint('mobile')} {
				padding: 12px 6px;
			}
			${EmotionBreakpoint('tablet')} {
				padding: 12px 6px;
			}
		}
	}

	.lp-hero-info-active {
		padding-top: 32px;
		padding-bottom: 32px;
		display: flex;
		width: 598px;
		flex-direction: row;
		align-items: center;
		gap: 4px;
		${EmotionBreakpoint('mobile')} {
			width: 100%;
			justify-content: flex-start;
			padding-top: 24px;
			padding-bottom: 24px;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
			justify-content: flex-start;
			padding-top: 24px;
			padding-bottom: 24px;
		}

		.plus-shipping {
			font-size: 16px;
			@media (max-width: 411px) {
				font-size: 13px !important;
			}
			${EmotionBreakpoint('mobile')} {
				width: max-content;
				font-size: 15px;
			}
			${EmotionBreakpoint('tablet')} {
				width: max-content;
				font-size: 15px;
			}
			.bon & {
				color: #222;
				font-family: 'FuturaPT';
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 22px;
			}

			.wsj & {
				color: #2b2a2f;
				font-family: Arial, sans-serif;
				font-style: normal;
				font-weight: 400;
				line-height: 24px;
			}
			.law & {
				color: #2b2a2f;
				font-family: 'Roboto';
				font-style: normal;
				font-weight: 400;
				line-height: 24px;
			}
			.osw & {
				color: #2b2a2f;
				font-family: 'Roboto';
				font-style: normal;
				font-weight: 700;
				line-height: 24px;
			}
			.npr & {
				color: #2b2a2f;
				font-family: 'Roboto';
				font-style: normal;
				font-weight: 400;
				line-height: 24px;
			}
		}

		.bonus-gifts {
			font-weight: 500; /* Bold */
			.law & {
				font-family: 'Roboto';
				font-weight: 700;
			}
			.osw & {
				font-family: 'Roboto';
				font-weight: 700;
			}
			.npr & {
				font-family: 'Roboto';
				font-weight: 700;
			}
			.wsj & {
				font-weight: 600;
			}
		}
		.product-price__original {
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px;
			@media (max-width: 411px) {
				font-size: 14px;
			}
			.wsj & {
				color: #2b2a2f;
				font-family: Arial;
			}
			.law & {
				font-family: 'Roboto';
			}
			.osw & {
				font-family: 'Roboto';
			}
			.npr & {
				font-family: 'Roboto';
			}
			.bon & {
				color: var(--Base-Colors-Black, #222);
				font-family: 'FuturaPT';
			}
		}

		.product-price__sale {
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			@media (max-width: 411px) {
				font-size: 14px;
			}

			.wsj & {
				color: var(--wsj-red, #e92440);
				font-family: Arial;
				font-weight: 600;
			}
			.bon & {
				color: #c20017;
				font-family: 'FuturaPT';
				font-size: 18px;
				font-style: normal;
				font-weight: 700;
				line-height: 22px;
			}
			.fox & {
				color: var(--Fox-Primary-Red-500, #c20017);
				font-family: Roboto;
			}
			.law & {
				font-family: 'Roboto';
				color: #cf004f;
				font-weight: 600;
			}
			.osw & {
				font-family: 'Roboto';
				font-weight: 600;
				color: #890419;
			}
			.npr & {
				font-family: 'Roboto';
				font-weight: 600;
				color: #d62120;
			}
		}

		.product-price__presale {
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			@media (max-width: 411px) {
				font-size: 14px;
			}

			.wsj & {
				color: #e92440;
				font-family: Arial;
				font-weight: 600;
			}
			.law & {
				font-family: 'Roboto';
				color: #cf004f;
				font-weight: 600;
			}
			.osw & {
				font-family: 'Roboto';
				font-weight: 600;
				color: #991200;
			}
			.fox & {
				color: #2954b6;
				font-family: Roboto;
				font-weight: 600;
			}
			.bon & {
				color: #c20017;
				font-family: 'FuturaPT';
				font-size: 18px;
				font-style: normal;
				font-weight: 700;
				line-height: 22px;
			}
			.npr & {
				font-family: 'Roboto';
				font-weight: 600;
				color: #d62120;
			}
		}
	}

	.mcs-selector__header {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 12px;
		margin-top: 19px;
		justify-content: space-between;
		width: 589px;

		span {
			color: var(--wsj-primary-ink-black, #2b2a2f);
			text-align: center;
			font-family: Arial;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px;
			.fox & {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: Roboto;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 140%;
			}

			.bon & {
				color: #000;
				font-family: 'FuturaPT';
				font-size: 26px;
				font-style: normal;
				font-weight: 450;
				line-height: 30px;
			}
			.law & {
				font-family: 'Roboto';
			}

			.osw & {
				font-family: 'Roboto';
			}

			.npr & {
				font-family: 'Roboto';
			}
			${EmotionBreakpoint('mobile')} {
				.bon & {
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					line-height: 20px;
				}
			}
		}

		a {
			color: var(--wsj-primary-ink-black, #2b2a2f);
			text-align: center;
			font-family: Arial;
			font-size: 16px;
			font-style: normal;
			font-weight: 700;
			line-height: 24px;
			text-decoration: underline;
			.fox & {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: Roboto;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 140%;
			}
			.bon & {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: 'FuturaPT';
				font-size: 18px;
				font-style: normal;
				font-weight: 500;
				line-height: 22px;
				letter-spacing: 0.48px;
				text-transform: uppercase;
			}
			.law & {
				font-family: 'Roboto';
				font-weight: 600;
			}

			.osw & {
				font-family: 'Roboto';
				font-weight: 600;
			}

			.npr & {
				font-family: 'Roboto';
				font-weight: 600;
			}
			${EmotionBreakpoint('mobile')} {
				.bon & {
					font-size: 16px;
					font-weight: 500;
				}
			}
		}

		${EmotionBreakpoint('mobile')} {
			width: 100%;
			height: 24px;
			margin-top: 19px;
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
			height: 24px;
		}
	}
	${({ isBackgroundMode, bannerTextColor }) =>
		isBackgroundMode &&
		`
		.mcs-selector__header span {
			color: ${bannerTextColor}!important;
		}
		.mcs-selector__header a {
			color: ${bannerTextColor}!important;
		}
		.lp-hero-info-active .product-price__original {
			color: ${bannerTextColor}!important;
		}
		.lp-hero-info-active .product-price__sale {
			color: ${bannerTextColor}!important;
		}
		.lp-hero-info-active .plus-shipping {
			color: ${bannerTextColor}!important;
		}
		.lp-hero-eyebrow,
		.lp-hero-heading {
			color: ${bannerTextColor}!important;
		}
	`}

	/* Rich text color: white only when the light text theme is active */
	${({ lightText }) => `
		.lp-hero-richtext,
		.lp-hero-richtext * {
			color: ${lightText ? '#ffffff' : '#2B2B2A'}!important;
		}
	`}

	.lp-hero-heading {
		font-family: Escrow;
		font-size: 24px;
		font-style: normal;
		font-weight: 400;
		line-height: 28px;
		margin-bottom: 12px;
		color: #000;
		text-align: left;
		.fox & {
			font-family: Roboto;
			font-size: 22px;
			font-style: normal;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.22px;
		}
		.bon & {
			font-family: 'FuturaPT';
			font-size: 26px;
			font-style: normal;
			font-weight: 450;
			line-height: 30px; /* 125% */
		}
		.law & {
			font-family: 'Noto Serif';
			font-size: 24px;
			font-weight: 500;
		}

		.osw & {
			font-family: 'Neue Haas Grotesk Text Pro';
			font-size: 22px;
		}

		.npr & {
			font-family: 'Gotham';
			font-size: 22px;
			font-weight: 400;
		}

		${EmotionBreakpoint('mobile')} {
			width: 100%;
			margin-bottom: 8px;
			text-align: start;
			font-size: 22px;
			.bon & {
				font-size: 18px;
			}
		}
		${EmotionBreakpoint('tablet')} {
			width: 100%;
			margin-bottom: 8px;
			text-align: start;
			font-size: 20px;
		}
		.hero-highlight-head {
			.bon & {
				color: #000 !important;
				font-weight: 450 !important;
			}
			.osw & {
				color: #222222 !important;
				font-weight: 400 !important;
			}
			.law & {
				color: #222222 !important;
				font-weight: 600 !important;
			}
			.npr & {
				color: #222222 !important;
				font-weight: 600 !important;
			}
		}
		.hero-highlight-desc {
			.osw & {
				color: #222222 !important;
				font-weight: 400 !important;
			}
			.law & {
				color: #222222 !important;
				font-weight: 600 !important;
			}
			.npr & {
				color: #222222 !important;
				font-weight: 600 !important;
			}
		}
	}

	.lp-hero-eyebrow {
		margin-bottom: 12px;
		font-size: 48px;
		font-style: normal;
		font-weight: 500;
		line-height: 112%;
		align-items: flex-start;
		text-align: left;
		.wsj & {
			font-family: 'Escrow Banner Compressed', sans-serif;
			color: #2b2a2f;
			text-transform: uppercase;
		}
		.bon & {
			color: #000;
			font-family: 'FuturaPT';
			font-size: 48px;
			font-style: normal;
			font-weight: 450;
			line-height: 58px;
		}
		.fox & {
			color: var(--Base-Colors-Black, #222);
			font-family: Roboto;
			font-size: 48px;
			font-style: normal;
			font-weight: 900;
			line-height: 105%;
			letter-spacing: -1.44px;
		}
		.law & {
			font-family: 'Oswald';
			text-transform: uppercase;
		}
		.osw & {
			font-family: 'Neue Aachen Pro';
		}
		.npr & {
			font-family: 'Gotham';
		}
		${EmotionBreakpoint('mobile')} {
			margin-top: 8px;
			font-size: 38px;
			margin-bottom: 8px;
			.npr & {
				font-family: 'Gotham';
				font-size: 30px;
			}
			.bon & {
				font-size: 30px;
			}
		}
		${EmotionBreakpoint('tablet')} {
			margin-top: 8px;
			font-size: 38px;
			margin-bottom: 8px;
		}
	}

	/* Rich Text Container - layout + theme sizing for widget tags */
	.lp-hero-richtext {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 4px;
		width: 100%;
		max-width: 598px;
		height: auto;
		min-height: fit-content;
		word-wrap: break-word;
		overflow-wrap: break-word;

		/* Neutralize global CSS on all elements */
		h1,
		h2,
		h3,
		h4,
		h5,
		h6,
		p,
		div,
		blockquote,
		pre {
			margin: 0;
			padding: 0;
			display: block;
		}

		span,
		strong,
		em,
		a {
			margin: 0;
			padding: 0;
			display: inline;
		}

		/* ── Theme defaults (brand-agnostic, overridable by inline styles) ── */ /* Heading XL — <hxl> → <h2 class="hxl"> */
		.hxl {
			font-size: 64px;
			font-weight: 500;
			line-height: 100%;
			letter-spacing: -0.04em;
			${EmotionBreakpoint('mobile')} {
				font-size: 45px;
			}
		}

		/* H1 */
		h1 {
			font-size: 48px;
			font-weight: 500;
			line-height: 105%;
			letter-spacing: -0.03em;
			${EmotionBreakpoint('mobile')} {
				font-size: 38px;
				letter-spacing: -0.04em;
			}
		}

		/* Custom H2 — <customh2> → <h2 class="custom-h2-header"> */
		.custom-h2-header {
			font-size: 48px;
			font-weight: 500;
			line-height: 105%;
			letter-spacing: -0.03em;
			${EmotionBreakpoint('mobile')} {
				font-size: 34px;
				letter-spacing: -0.04em;
			}
		}

		/* H2 (plain, not .hxl or .custom-h2-header) */
		h2:not(.hxl):not(.custom-h2-header) {
			font-size: 34px;
			font-weight: 500;
			line-height: 105%;
			letter-spacing: -0.03em;
			${EmotionBreakpoint('mobile')} {
				font-size: 30px;
				letter-spacing: -0.04em;
			}
		}

		/* H3 */
		h3 {
			font-size: 30px;
			font-weight: 500;
			line-height: 110%;
			letter-spacing: -0.02em;
			${EmotionBreakpoint('mobile')} {
				font-size: 28px;
				line-height: 105%;
			}
		}

		/* H4 */
		h4 {
			font-size: 22px;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.01em;
			${EmotionBreakpoint('mobile')} {
				font-size: 22px;
			}
		}

		/* H5 */
		h5 {
			font-size: 26px;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.01em;
			${EmotionBreakpoint('mobile')} {
				font-size: 24px;
			}
		}

		/* H6 (plain, not .h7 or .h8) */
		h6:not(.h7):not(.h8) {
			font-size: 22px;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.01em;
			${EmotionBreakpoint('mobile')} {
				font-size: 20px;
			}
		}

		/* H7 — <h7> → <h6 class="h7"> */
		.h7 {
			font-size: 18px;
			font-weight: 600;
			line-height: 140%;
			letter-spacing: 0em;
			${EmotionBreakpoint('mobile')} {
				font-size: 16px;
				font-weight: 700;
				letter-spacing: 0.01em;
			}
		}

		/* H8 — <h8> → <h6 class="h8"> */
		.h8 {
			font-size: 18px;
			font-weight: 700;
			line-height: 140%;
			letter-spacing: 0.01em;
			${EmotionBreakpoint('mobile')} {
				font-size: 16px;
			}
		}

		/* Eyebrow Regular — <eyebrow> → <p class="eyebrowRegular"> */
		.eyebrowRegular {
			font-size: 18px;
			font-weight: 700;
			line-height: 140%;
			letter-spacing: 0.04em;
			text-transform: uppercase;
			${EmotionBreakpoint('mobile')} {
				font-size: 18px;
			}
		}

		/* Eyebrow Small — <eyebrowSmall> → <p class="eyebrowSmall"> */
		.eyebrowSmall {
			font-size: 12px;
			font-weight: 600;
			line-height: 140%;
			letter-spacing: 0.04em;
			text-transform: uppercase;
			${EmotionBreakpoint('mobile')} {
				font-size: 10px;
			}
		}

		/* Paragraph (Body 1) — plain <p> without custom classes */
		p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
				.utilityMedium
			):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall) {
			font-size: 16px;
			font-weight: 400;
			line-height: 140%;
			letter-spacing: 0em;
		}

		/* Body 2 — <body2> → <p class="body2"> */
		.body2 {
			font-size: 14px;
			font-weight: 400;
			line-height: 130%;
			letter-spacing: 0em;
		}

		/* Body 3 / Body Small — <body3> → <p class="bodySmall"> */
		.bodySmall {
			font-size: 12px;
			font-weight: 400;
			line-height: 130%;
			letter-spacing: 0em;
		}

		/* Utility Small — <utilitySmall> → <p class="utility"> */
		.utility {
			font-size: 12px;
			font-weight: 600;
			line-height: 100%;
			letter-spacing: 0.03em;
			text-transform: uppercase;
			${EmotionBreakpoint('mobile')} {
				font-size: 10px;
				line-height: 120%;
				letter-spacing: 0.04em;
			}
		}

		/* Utility Medium — <utilityMedium> → <p class="utilityMedium"> */
		.utilityMedium {
			font-size: 14px;
			font-weight: 600;
			line-height: 14px;
			letter-spacing: 0.03em;
			text-transform: uppercase;
		}

		/* Utility Large — <utilityLarge> → <p class="utilityLarge"> */
		.utilityLarge {
			font-size: 16px;
			font-weight: 600;
			line-height: 18px;
			letter-spacing: 0.03em;
			text-transform: uppercase;
		}

		/* Caption — <customCaption> → <p class="caption"> */
		.caption {
			font-size: 12px;
			font-weight: 400;
			line-height: 120%;
			letter-spacing: 0em;
		}

		/* Blockquote */
		blockquote {
			font-size: 28px;
			font-style: italic;
			line-height: 120%;
			letter-spacing: -0.04em;
			${EmotionBreakpoint('mobile')} {
				font-size: 20px;
			}
		}

		/* Pre / Source code */
		pre {
			font-family: monospace;
			background: #f5f5f5;
			padding: 1rem;
			border-radius: 4px;
			overflow-x: auto;
		}

		/* ── Brand-specific overrides ── */

		/* WSJ — Escrow Banner Compressed for headlines, Escrow for subheadings, Arial for eyebrow + body, uppercase headings */
		.wsj & {
			h1,
			h2,
			h3,
			.hxl {
				font-family: 'Escrow Banner Compressed', sans-serif;
				font-weight: 700;
				font-size: 48px;
				line-height: 112%;
				text-transform: uppercase;
				color: #000;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
					line-height: 94.737%;
				}
			}
			.custom-h2-header {
				font-family: 'Escrow', serif;
				font-weight: 400;
				font-size: 22px;
				line-height: normal;
				text-transform: none;
				color: #000;
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: 'Escrow', serif;
				color: #000;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: Arial, sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 112%;
				text-transform: uppercase;
				color: #000;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: Arial, sans-serif;
				font-weight: 400;
				font-size: 16px;
				line-height: 140%;
				color: #000;
			}
		}

		/* FOX — Roboto for everything, no uppercase */
		.fox & {
			h1,
			h2,
			h3,
			.hxl {
				font-family: Roboto, sans-serif;
				font-weight: 700;
				font-size: 48px;
				line-height: 112%;
				letter-spacing: -1.44px;
				color: #000;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
				}
			}
			.custom-h2-header {
				font-family: Roboto, sans-serif;
				font-weight: 500;
				font-size: 22px;
				line-height: 127.273%;
				color: #000;
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: Roboto, sans-serif;
				font-weight: 700;
				color: #000;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: Roboto, sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 112%;
				text-transform: uppercase;
				color: #000;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: Roboto, sans-serif;
				font-weight: 400;
				font-size: 16px;
				line-height: 140%;
				color: #000;
			}
		}

		/* NPR — Gotham for headlines/eyebrow, Roboto for body, no uppercase */
		.npr & {
			h1,
			h2,
			h3,
			.hxl,
			.custom-h2-header {
				font-family: 'Gotham', sans-serif;
				font-weight: 700;
				color: #222;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
				}
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: 'Gotham', sans-serif;
				font-weight: 700;
				color: #222;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: 'Gotham', sans-serif;
				font-weight: 700;
				color: #222;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: 'Roboto', sans-serif;
				color: #222;
			}
		}

		/* OSW — Neue Aachen Pro for headlines, Neue Haas Grotesk Display for subheadings, Roboto for eyebrow + body */
		.osw & {
			h1,
			h2,
			h3,
			.hxl {
				font-family: 'Neue Aachen Pro', sans-serif;
				font-weight: 400;
				font-size: 48px;
				line-height: 108.333%;
				color: #000;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
				}
			}
			.custom-h2-header {
				font-family: 'Neue Haas Grotesk Display', sans-serif;
				font-weight: 450;
				font-size: 22px;
				line-height: 116.667%;
				color: #000;
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: 'Neue Haas Grotesk Display', sans-serif;
				font-weight: 450;
				color: #000;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: 'Roboto', sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 112%;
				text-transform: uppercase;
				color: #000;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: 'Roboto', sans-serif;
				font-weight: 400;
				font-size: 16px;
				line-height: 140%;
				color: #000;
			}
		}

		/* LAW — Oswald for headlines (uppercase), Noto Serif for subheadings, Roboto for eyebrow + body */
		.law & {
			h1,
			h2,
			h3,
			.hxl {
				font-family: 'Oswald', sans-serif;
				font-weight: 500;
				font-size: 48px;
				line-height: 112%;
				letter-spacing: -1.44px;
				text-transform: uppercase;
				color: #000;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
				}
			}
			.custom-h2-header {
				font-family: 'Noto Serif', serif;
				font-weight: 500;
				font-size: 22px;
				line-height: 116.667%;
				text-transform: none;
				color: #000;
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: 'Noto Serif', serif;
				color: #000;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: 'Roboto', sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 112%;
				text-transform: uppercase;
				color: #000;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: 'Roboto', sans-serif;
				font-weight: 400;
				font-size: 16px;
				line-height: 140%;
				color: #000;
			}
		}

		/* BON — FuturaPT for everything, lighter headline weight, no uppercase */
		.bon & {
			h1,
			h2,
			h3,
			.hxl,
			.custom-h2-header {
				font-family: 'FuturaPT', sans-serif;
				font-weight: 450;
				color: #000;
				${EmotionBreakpoint('mobile')} {
					font-size: 38px;
				}
			}
			h4,
			h5,
			h6,
			.h7,
			.h8 {
				font-family: 'FuturaPT', sans-serif;
				font-weight: 450;
				color: #000;
			}
			.eyebrowRegular,
			.eyebrowSmall {
				font-family: 'FuturaPT', sans-serif;
				font-weight: 500;
				color: #000;
			}
			p:not(.eyebrowRegular):not(.eyebrowSmall):not(.utility):not(
					.utilityMedium
				):not(.utilityLarge):not(.caption):not(.body2):not(.bodySmall),
			.body2,
			.bodySmall,
			.utility,
			.utilityMedium,
			.utilityLarge,
			.caption {
				font-family: 'FuturaPT', sans-serif;
				font-weight: 400;
				color: #000;
			}
		}

		${EmotionBreakpoint('mobile')} {
			max-width: 100%;
		}
		${EmotionBreakpoint('tablet')} {
			max-width: 100%;
		}
	}
`;

const HeroImage = styled.div`
	position: relative;
	flex: 1;
	max-width: 100%;
	height: 133%;
	text-align: start;
	${EmotionBreakpoint('mobile')} {
		flex: none;
		max-width: 100%;
		width: 100%;
		height: 100%;
	}
	${EmotionBreakpoint('tablet')} {
		flex: 1;
		max-width: 100%;
		width: 100%;
		height: 133%;
	}
	img {
		max-width: 100%;
		height: 592px;
		${EmotionBreakpoint('mobile')} {
			height: auto;
		}
		${EmotionBreakpoint('tablet')} {
			height: auto;
		}
		@media (width: 1024px) {
			height: 350px;
		}
	}
`;

const HeroBulletList = styled.ul`
	display: flex;
	flex-flow: column;
	align-items: center;
	padding: 0;
	margin-top: 20px;

	@media (min-width: 768px) {
		/* Adjust this breakpoint as per your design */
		flex-flow: row;
		justify-content: center;
	}

	li {
		display: flex;
		flex-flow: column;
		align-items: center;
		list-style: none;
		${({ lightText }) => lightText && `color: #ffffff;`}
		.bon & {
			color: #222;
			font-family: 'FuturaPT';
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
			${({ lightText }) => lightText && `color: #ffffff;`}

			${EmotionBreakpoint('mobile')} {
				${({ lightText }) => (lightText ? `color: #ffffff;` : `color: #222;`)}
			}
		}
		.law & {
			font-family: 'Roboto';
			font-weight: 400;
		}
		.osw & {
			font-family: 'Roboto';
			font-weight: 400;
			font-size: 14px;
		}
		.npr & {
			font-family: 'Roboto';
			font-weight: 400;
			font-size: 14px;
		}

		@media (min-width: 768px) {
			flex-flow: row;
		}
	}

	li:not(:first-child) {
		padding-top: 8px;

		&:before {
			content: '';
			width: 4px;
			height: 4px;
			background: ${({ lightText }) => (lightText ? '#ffffff' : '#222222')};
			border-radius: 100%;
			margin-bottom: 8px;
			display: block;
		}

		@media (min-width: 768px) {
			padding: 0 0 0 24px;

			&:before {
				margin: 0 24px 0 0;
			}
		}
	}
`;

const HeroVoucher = styled.div`
	background: ${(props) => props.bgColor || '#e6eff7'};
	color: ${(props) => props.textColor || '#033a6b'};
	display: flex;
	align-items: center;
	border-radius: 32px;
	width: 598px;
	height: 40px;
	justify-content: center;
	gap: 16px;
	margin-top: 2px;
	.fox & {
		margin-top: 12px;
	}
	.bon & {
		margin-top: 12px;
	}
	.npr & {
		margin-top: 12px;
	}
	${EmotionBreakpoint('mobile')} {
		width: 100%;
		padding: 16px;
		height: 56px;
		text-align: left;
	}
	${EmotionBreakpoint('tablet')} {
		width: 100%;
		padding: 16px;
		height: 56px;
		text-align: left;
	}

	img {
		margin-right: 1rem;
		width: 24px;
		height: 24px;
		${EmotionBreakpoint('mobile')} {
			margin-right: 0px;
		}
		${EmotionBreakpoint('tablet')} {
			margin-right: 0px;
		}
	}

	span {
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 20px;
		.fox & {
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 130%;
		}
		.bon & {
			font-family: 'FuturaPT';
			font-size: 18px;
			font-style: normal;
			font-weight: 500;
			line-height: 22px;
		}
		.law & {
			font-family: 'Roboto';
			font-weight: 600;
		}
		.osw & {
			font-family: 'Roboto';
			font-weight: 600;
		}
		.npr & {
			font-family: 'Roboto';
			font-weight: 600;
		}
		.wsj & {
			font-family: 'Arial';
			font-weight: 700;
		}
	}
`;

const HeroCarousel = styled.div`
	position: absolute;
	bottom: 7px;
	right: 24px;
	display: flex;
	align-items: center;
	gap: 50px;
	width: 124px;
	height: 43px;
	border-radius: 32px;
	opacity: 1;
	padding: 10px 23px;
	background: #22222259;
	z-index: 2;

	${EmotionBreakpoint('mobile')} {
		${({ isBackgroundMode }) =>
			isBackgroundMode
				? `
			top: 199px;
			bottom: auto;
			right: 16px;
			left: auto;
			width: 83.1px;
			height: 28.52px;
			border-radius: 21.42px;
			gap: 33.47px;
			padding: 6.69px 14.73px;
			background: #22222280;
		`
				: `
			bottom: 12px;
			top: auto;
			right: 16px;
			left: auto;
			width: 83.1px;
			height: 28.52px;
			border-radius: 21.42px;
			gap: 33.47px;
			padding: 6.69px 14.73px;
			background: #22222280;
		`}

		img {
			width: 16px;
			height: 16px;
		}

		img.carousel-arrow-icon {
			width: 10px;
			height: 24px;
		}
	}
	${EmotionBreakpoint('tablet')} {
		bottom: 16px;
		right: 16px;
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		margin: 0;
		border: none;
		background: transparent;
		cursor: pointer;

		&:disabled {
			opacity: 0.4;
			cursor: not-allowed;
		}

		img {
			width: 24px;
			height: 24px;
			display: block;
		}
	}

	.carousel-arrow-icon {
		width: 14px;
		height: 24px;
		display: block;
	}
`;

const HeroProductsForm = ({
	contentfulData,
	products = [],
	setActiveProduct,
	activeProductIndex = 0,
	setActiveProductIndex,
	activeProduct,
	brandTag,
	wineClubOffer,
	isFirstSection = false,
}) => {
	const {
		// Fields that remain on the landingPage entry itself.
		heroVoucherIcon,
		heroImageMobile = [],
		heroImageDesktop = [],
		customProductTitles = [],
		productCodes = [],
		voucherCopy = [],
	} = contentfulData || {};

	// Hero copy/voucher/display fields moved to the linked `pageHeroBanner`
	// entry (landingPage.reference). Optional: falls back to {} when not linked.
	const {
		// pageEyebrow - REMOVED: replaced by pageHeroText (plain text field with HTML support)
		pageHeroText,
		heroVoucherText,
		heroVoucherBackgroundColor,
		heroVoucherTextColor,
		voucherBackgroundColor,
		voucherTextColor,
		heroBulletPoints,
		heroBuelletPoints,
		pageSubheadline,
		heroDisplayStyle: heroDisplayStyleRaw,
	} = getPageHeroBannerFields(contentfulData);
	// Default to 'cropped' when heroDisplayStyle has no value
	const heroDisplayStyle = heroDisplayStyleRaw || 'cropped';
	const isFox = brandTag === 'fox';
	const isBon = brandTag === 'bon';

	const bgColor =
		isFox || isBon
			? heroVoucherBackgroundColor?.value
			: voucherBackgroundColor?.value;
	const textColor =
		isFox || isBon ? heroVoucherTextColor?.value : voucherTextColor?.value;

	const shouldShowOriginalPrice = wineClubOffer === false;

	// Get the deposit price for presell items from the active product's SKU
	const getDepositPrice = () => {
		const sku = activeProduct?.skus?.[0];
		if (!sku?.preSellItem || !sku?.paymentInstallmentSchedule?.installments) {
			return null;
		}
		// Find the deposit installment (productDispatchFlag: false means it's the deposit)
		const depositInstallment = sku.paymentInstallmentSchedule.installments.find(
			(installment) => installment.productDispatchFlag === false
		);
		const price = depositInstallment?.installmentPrice;
		// Validate deposit price: must be a positive number
		if (price === null || price === undefined || price <= 0) {
			return null;
		}
		return price;
	};

	// Check if the active product is a presell item (product-level check)
	const isActiveProductPresell = activeProduct?.skus?.[0]?.preSellItem === true;

	// Compute deposit price once to avoid multiple function calls in JSX
	const depositPrice = getDepositPrice();

	const handleProductClick = (index) => {
		setActiveProductIndex(index);
		setActiveProduct(products[index]);

		window.dispatchEvent(
			new CustomEvent('checkoutOptionSelected', {
				detail: { index, itemCode: products[index].itemCode },
			})
		);
	};

	// For the bon brand the icon path segment is 'bonapp' instead of 'bon'
	const iconBrandTag = brandTag === 'bon' ? 'bonapp' : brandTag;

	// The hero image is controlled independently from the product/case selection.
	// Clicking a case button only changes the active product (price, etc.), while
	// the carousel arrows are the only way to change the displayed image.
	const [activeImageIndex, setActiveImageIndex] = useState(0);
	const imageCount = heroImageDesktop?.length || 0;

	// Carousel navigation handlers: change ONLY the displayed image.
	// The case/product selection is intentionally left untouched — the case
	// buttons are the only control that changes the active product.
	const handleCarouselPrev = () => {
		if (imageCount <= 1) return;
		setActiveImageIndex((prev) => (prev - 1 + imageCount) % imageCount);
	};

	const handleCarouselNext = () => {
		if (imageCount <= 1) return;
		setActiveImageIndex((prev) => (prev + 1) % imageCount);
	};

	const scrollToOrderButton = () => {
		// Query the element by its class
		const buttonElem = document.querySelector('.case-title');
		if (buttonElem) {
			const elementTop =
				buttonElem.getBoundingClientRect().top + window.scrollY;
			window.scrollTo({
				top: elementTop - 120,
				behavior: 'smooth',
			});
		}
	};

	const formatPageSubheadline = (pageSubheadline) => {
		// pageSubheadline lives on the linked Page Hero Banner entry, so it can be
		// undefined when that entry isn't populated. Guard before string methods.
		if (!pageSubheadline || typeof pageSubheadline !== 'string') return null;
		if (!pageSubheadline.includes('+ BONUS GIFTS')) return pageSubheadline; // Return text unchanged if no match

		const parts = pageSubheadline.split('+ BONUS GIFTS'); // Split into two parts

		return (
			<>
				<span className='plus-shipping-text'>{parts[0]}</span>
				<span className='bonus-gifts'>+ BONUS GIFTS</span>
			</>
		);
	};

	// Check if pageHeroText has meaningful content (not just empty HTML tags like "<p><br></p>")
	const hasHeroTextContent = () => {
		const text = pageHeroText;
		if (!text) return false;
		// Strip HTML tags and check if there's actual text content
		const strippedText = text.replace(/<[^>]*>/g, '').trim();
		return strippedText.length > 0;
	};

	// Determine the hero display mode from heroDisplayStyle (Contentful).
	// Layout and text theme are now decoupled:
	// - 'cropped'                  -> default design (image beside the content)
	// - 'fullWidthGradientLight'   -> full-width image, gradient overlay, white text
	// - 'fullWidthGradientDark'    -> full-width image, gradient overlay, dark text
	// - 'fullWidthNoOverlayLight'  -> full-width image, no overlay, white text
	// - 'fullWidthNoOverlayDark'   -> full-width image, no overlay, dark text
	const activeDesktopImage = heroImageDesktop?.[activeImageIndex];
	const activeMobileImage = heroImageMobile?.[activeImageIndex];
	// Any full-width variant turns on background mode
	const isBackgroundMode = heroDisplayStyle.startsWith('fullWidth');
	// Gradient overlay only for the gradient variants
	const showGradient = heroDisplayStyle.startsWith('fullWidthGradient');
	// Text theme is independent of the layout: an explicit "Dark" suffix = dark text,
	// everything else in background mode = light (white) text.
	const isDarkText = heroDisplayStyle.endsWith('Dark');
	// Convenience flag: light (white) text styling is active
	const lightText = isBackgroundMode && !isDarkText;
	// Text color inside the banner
	const bannerTextColor = isDarkText ? '#2B2B2A' : '#ffffff';
	const backgroundImageUrl = isBackgroundMode
		? activeDesktopImage?.fields?.file?.url
		: null;
	const backgroundImageMobileUrl = isBackgroundMode
		? activeMobileImage?.fields?.file?.url || backgroundImageUrl
		: null;

	// Shared carousel element (rendered inside the image for cropped mode,
	// and at the container level for full-width background mode).
	// Only shown when more than one image has been uploaded.
	const carousel = imageCount > 1 && (
		<HeroCarousel isBackgroundMode={isBackgroundMode}>
			<button
				type='button'
				aria-label='Previous product'
				onClick={handleCarouselPrev}
			>
				<img
					src={`/images/us/${iconBrandTag}/common/icons/white-arrow-left.svg`}
					alt='Previous'
					className='carousel-arrow-icon'
				/>
			</button>
			<button
				type='button'
				aria-label='Next product'
				onClick={handleCarouselNext}
			>
				<img
					src={`/images/us/${iconBrandTag}/common/icons/white-arrow-right.svg`}
					alt='Next'
					className='carousel-arrow-icon'
				/>
			</button>
		</HeroCarousel>
	);

	return (
		<div>
			{isFirstSection && (
				<BannerHeightAdjust
					isBackgroundMode={isBackgroundMode}
				></BannerHeightAdjust>
			)}
			<HeroContainer
				className={
					hasHeroTextContent()
						? 'has-richtext container-position'
						: 'container-position'
				}
				backgroundImageUrl={backgroundImageUrl}
				backgroundImageMobileUrl={backgroundImageMobileUrl}
				showGradient={showGradient}
			>
				<HeroInner
					isBackgroundMode={isBackgroundMode}
					isFirstSection={isFirstSection}
				>
					<HeroInfo
						isBackgroundMode={isBackgroundMode}
						bannerTextColor={bannerTextColor}
						showGradient={showGradient}
						lightText={lightText}
					>
						<div className='lp-hero'>
							{/* Hero Text - pageHeroText from Contentful (plain text with HTML support) with fallback */}
							{hasHeroTextContent() ? (
								<div
									className='lp-hero-richtext'
									dangerouslySetInnerHTML={{
										__html: pageHeroText,
									}}
								/>
							) : (
								<>
									<span className='lp-hero-eyebrow'>
										Taste Top-Rated Discoveries
									</span>
									<p className='lp-hero-heading'>
										Join now with today's welcome offer
									</p>
								</>
							)}
						</div>

						{productCodes?.length === 1 && (
							<div className='mcs-selector__header'>
								<a className='eyebrow' onClick={scrollToOrderButton}>
									What's in the case?
								</a>
							</div>
						)}

						{productCodes?.length > 1 && (
							<>
								<div className='mcs-selector__header'>
									<span>Choose your case</span>
									<a className='eyebrow' onClick={scrollToOrderButton}>
										{brandTag === 'fox'
											? "What's in the case"
											: "What's in the case?"}
									</a>
								</div>
								<div className='hero-form-selector-container'>
									{productCodes?.map((code, index) => (
										<SelectorButtonContainer
											key={code}
											product={{
												name:
													customProductTitles[index] || `Product ${index + 1}`,
												itemCode: code,
											}}
											isActive={index === activeProductIndex}
											onClick={() => handleProductClick(index)}
											isBackgroundMode={isBackgroundMode}
											bannerTextColor={bannerTextColor}
										/>
									))}
								</div>
							</>
						)}

						{activeProduct && (
							<div className='lp-hero-info-active'>
								{isActiveProductPresell && depositPrice !== null ? (
									// Presale deposit pricing display
									<span className='product-price__presale'>
										Preorder with a deposit of ${depositPrice}
									</span>
								) : (
									// Regular pricing display
									activeProduct?.skus?.[0]?.salePrice && (
										<>
											{activeProduct?.skus?.[0]?.listPrice &&
												shouldShowOriginalPrice && (
													<s className='product-price__original'>
														${activeProduct?.skus[0]?.listPrice}
													</s>
												)}
											<span className='product-price__sale'>
												${activeProduct?.skus[0]?.salePrice}
											</span>
											<span className='plus-shipping'>
												{formatPageSubheadline(pageSubheadline)}
											</span>
										</>
									)
								)}
							</div>
						)}
						<ProductButton
							text={isActiveProductPresell ? 'PREORDER NOW' : 'ORDER NOW'}
							className='hero-form-product-button'
							voucherCopy={voucherCopy}
						/>
						{heroVoucherText && (
							<HeroVoucher bgColor={bgColor} textColor={textColor}>
								{heroVoucherIcon?.fields?.file?.url && (
									<img
										src={`https:${heroVoucherIcon.fields.file.url}`}
										alt='Voucher Icon'
									/>
								)}
								<span>{heroVoucherText}</span>
							</HeroVoucher>
						)}
						{(heroBulletPoints ?? heroBuelletPoints)?.length > 0 && (
							<HeroBulletList
								isBackgroundMode={isBackgroundMode}
								bannerTextColor={bannerTextColor}
								showGradient={showGradient}
								lightText={lightText}
							>
								{(heroBulletPoints ?? heroBuelletPoints).map((point, idx) => (
									<li key={idx}>{point}</li>
								))}
							</HeroBulletList>
						)}
					</HeroInfo>
					{!isBackgroundMode && (
						<HeroImage>
							<picture>
								<source
									media='(max-width: 768px)'
									srcSet={
										heroImageMobile?.[activeImageIndex]?.fields?.file?.url
									}
								/>
								<source
									media='(min-width: 769px)'
									srcSet={
										heroImageDesktop?.[activeImageIndex]?.fields?.file?.url
									}
								/>
								<img
									src={heroImageDesktop?.[activeImageIndex]?.fields?.file?.url}
									alt={`Hero Image ${activeImageIndex + 1}`}
								/>
							</picture>
							{carousel}
						</HeroImage>
					)}
				</HeroInner>

				{isBackgroundMode && carousel}
			</HeroContainer>
			<HeroContainerAdjust
				className={hasHeroTextContent() ? 'has-richtext' : ''}
			/>
		</div>
	);
};

export default HeroProductsForm;
